import {createLazyFileRoute} from '@tanstack/react-router'

import Checkout from '@/views/Flight/Checkout'

export const Route = createLazyFileRoute('/_flight/flights/checkout/')({
  component: Checkout,
})
